import { createContext } from 'react';
export var GlobalContext = /*#__PURE__*/createContext({
  lang: 'zh-CN'
});